import { ProductType } from '@sso/shared/constants';

export const features = {
    [ProductType.As]: [
        'Deploy on Docker, Linux, Hyper-V, and VMware ESXi',
        'Quick launch template for AWS',
        'Internet traffic is routed through the installed Access Server',
        'Identity-based access control, device identity, and IP address checks, more coming soon',
        'Routing based on domain names is coming soon',
    ],
    [ProductType.Cloud]: [
        '30+ worldwide PoPs create a private overlay network',
        'Connect your networks with OpenVPN or IPsec',
        'Need to connect an internet gateway for internet access through the VPN',
        'Full suite of zero trust controls',
        'Content filtering and IDS/IPS',
        'Simple routing configuration based on application domain names',
    ],
    [ProductType.Support]: [],
};
